// extracted by mini-css-extract-plugin
export default {"brandPromo":"xG-z","carousel":"yG-z"};